export default function () {
  let sidepanelToggler = document.querySelector('.sidepanel-toggler');
  let sidepanel = document.querySelector('.sidepanel');

  function toggleSidepanel () {
    sidepanel.classList.toggle('sidepanel--hidden');
  }

  // sidepanel hides after scrolling page 500px from top
  function hideSidepanelAtPosition () {
    if (window.scrollY > 500) {
      sidepanel.classList.add('sidepanel--hidden');
    }
  }

  window.addEventListener('scroll', hideSidepanelAtPosition)

  sidepanelToggler.addEventListener('click', function () {
    // if sidepanel is clicked after position of 500px from top
    if (window.scrollY > 500) {
      // first it is opened
      toggleSidepanel()

      // then scroll event is disabled
      window.removeEventListener('scroll', hideSidepanelAtPosition, false)

      // then after 2.5s it is enabled again
      setTimeout(function () {
        window.addEventListener('scroll', hideSidepanelAtPosition)
      }, 2500);
    } else {
      toggleSidepanel()
    }
  })
}
